import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { toast } from 'react-toastify';
import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';
import _ from "lodash";
// Component
import AddUserModal from "./AddUserModal";
import AdminDashboard from "./AdminDashboard";
import EditUserModal from "./EditUserModal";
import AboutOrganisationModal from "../Organisations/AboutOrganisationModal";
import BulkImportUserModal from "./BulkImportUserModal"
import QRPopUp from "./QRPopUp";
import Spinner from "COMPONENTS/Spinner/Spinner";
import SupportCenterContainer from 'COMPONENTS/SuperAdmin/SupportCenter/SupportCenterContainer';
import { SupportCenterReportContainer } from 'COMPONENTS/SuperAdmin/SupportCenter/Report/SupportCenterReportContainer';

import { getCustomerId, getUserId, getSessionsCount,
  getSessionListPageSize, getSessionListCurrentPageNo , getSmsSentNumPageNo,
  getUserListPageSize ,getUserListCurrentPageNo ,getUsersCount} from "../../MainLayout/selectors";
import { getIsSSOEnabled } from "../../CommonComponents/Header/selectors";
import { userAction, organisationAction, inviteeAction as actionFactory } from "CONFIG/ActionFactory";
import { setPasswordAction } from "CONFIG/ActionFactory";
// Strings
import { getMessage } from "CONFIG/i18n";

// Utilities
import { CONFIG } from "UTILS/Constants";

// Images
import logo from "ASSETS/Images/img_header_logo.webp";

import { ERROR,RECORD_NOT_PROCESSED } from "UTILS/Constants";
import AddUserDropdown from "../Header/AddUserDropdown";

class UsersContainer extends Component {
  constructor(props) {
    super(props);
    this.adminDashboardRef = React.createRef();
    this.state = {
      addUserdata: {
        id: "",
        first_name: "",
        last_name: "",
        role: "",
        email: "",
        customerId: this.props.customerId,
        status: "",
        useId: false,
        password: "",
        confirmPassword: "",
        operatorSkills: [],
      },
      editUserData: {
        id: "",
        first_name: "",
        last_name: "",
        role: "",
        email: "",
        customerId: this.props.customerId,
        status: "",
        useId: false,
        password: "",
        confirmPassword: "",
        isOperator: false,
        operatorSkills: [],
      },
      showAddUserModalFlag: false,
      showEditUserModalFlag: false,
      showResetPasswordModalFlag: false,
      showResetPasswordUsesIdModalFlag: false,
      newResetPassword: "",
      confirmResetPassword: "",
      deleteUserIndex: null,
      showConfirmationModalFlag: false,
      customerId: this.props.customerId,
      errorMessage: "",
      deleteTarget: "",
      isOnlyOneAdmin: "",
      organizationData: { modules: [] },
      showQRPopUp: false,
      showQR: false,
      baseUrl: "",
      spinnerVisibility: false,
      sessionsList:[],
      usersList: [],
      sessionDetails: null,
      sessionObjects: [],
      recordingObjects: [],
      inviteesList:[],
      customerStatistics:{},
      showBulkImportUserModalFlag: false,
      showAddUserDropdownFlag: false,
      showAboutOrgModalFlag: false,
      smsSendNumList: [],
      encodingTimeList: [],
      showInitializeMfaModalFlag: false,
      setPasswordTarget: "",
      isSupportCenter: false,
      originalSkills: [],
    };
  }

  componentDidMount() {
    this.showSpinner();
    this.fetchSessionsList();
    this.smsSendNumber();
    this.encodingTime();
    this.getAllUserData();
    this.getCustomerInfo();
    this.getCustomerStatistics();
    if(this.props.sessionKey) {
      this.showSpinner();
      this.getSessionInvitiesAndSessionDetails(this.props.sessionKey)
    }
    // this.getSessionInvitiesAndSessionDetails(this.props.sessionKey);
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.currentActiveTab != prevProps.currentActiveTab)
      userAction.saveSessionKey(null);
    if(prevProps.logoUrl != this.props.logoUrl)
      organisationAction.setLogoUrl(this.props.logoUrl);
  }

  fetchSessionsList = (page=this.props.sessionListCurrentPageNo, sessionListPageSize , searchKey) => { 
    const pageSize = sessionListPageSize ? sessionListPageSize 
      : this.props.sessionListPageSize 
        ? this.props.sessionListPageSize
        : 10;
    let requestBodyData = {
      customerId: this.props.customerId,
      search:searchKey,
      limit:pageSize,
      page
    }
    userAction.getSessionListAction(requestBodyData).then(
      response => {
        this.setState({
          sessionsList: response.data.data.sessionsList
        })
        userAction.saveSessionListCurrentPageNo(page);
      },
      error => {
        console.log(error);
      }
    );
  }

  smsSendNumber = (page=this.props.smsSentNumPageNo, sessionListPageSize , searchKey) => { 
    organisationAction.getCustomerSmsSendNum().then(
      response => {
        this.setState({
          smsSendNumList: response.data.data.smsSendInfo
        })
      },
      error => {
        console.log(error);
      }
    );
  }

  encodingTime = () => {
    organisationAction.getCustomerEncodingTime().then(
      response => {
        this.setState({
          encodingTimeList: response.data.data.encodingTimeInfo
        })
      },
      error => {
        console.log(error);
      }
    );
  }

  getAllUserData = (page=this.props.userListCurrentPageNo, userListPageSize , searchKey) => {
    const pageSize = userListPageSize ? userListPageSize 
      : this.props.userListPageSize 
        ? this.props.userListPageSize
        : 10;
    let requestBodyData = { 
      customerId: this.state.customerId ,
      page,
      limit:pageSize,
      search:searchKey
    }
    
    // will not set searchKey in state if it is not modified to avoid re-rendering
    this.setState(prevState => {
      if (prevState.searchKey === searchKey) {
        return null;
      } else {
        return { searchKey };
      }  
    });

    userAction.getAllUsersAction(requestBodyData).then(
      response => {
        this.setState({
          usersList: response.data.data.users,
          showTable: true
        }, () => {
          // this.hideSpinner();
        });
        userAction.saveUserListCurrentPageNo(page);
      },
      error => {
        // this.hideSpinner();
      }
    );
  };

  getCustomerInfo = () => {
    this.showSpinner();
    organisationAction.getCustomersAction(this.props.customerId).then(
      responseObject => {
        let organizationData = responseObject.data.data;
        // organizationData.logo += `?lastModified=${new Date().getTime()}`;
        this.setState({ organizationData }, () => this.getBaseUrl());
        organisationAction.setLogoUrl(organizationData.logo || logo);
        let moduleArray = responseObject.data.data ? responseObject.data.data.modules : []
        this.setState({ showQR: moduleArray.indexOf("QR_CODE") !== -1 ? true : false });
        this.setState({ isSupportCenter: moduleArray.includes('SUPPORT_CENTER') })
        this.hideSpinner();
      },
      error => {
        this.hideSpinner();
      }
    );
  };

  getCustomerStatistics=() =>{
    organisationAction.getCustomerStatisticsAction(this.props.customerId).then(
      customerStatistics=>{
        this.setState({customerStatistics:customerStatistics.data.data})
      },
      error => {
      }
    );
  };

  renderSpinner = () => {
    return <Spinner showSpinner={this.state.spinnerVisibility} />;
  }

  uploadImage = (formData) => {
    this.showSpinner();
    organisationAction.uploadOrgLogoStatusAction(formData).then(
      response_data => {
        this.getCustomerInfo();
      },
      error => {
        this.hideSpinner();
        if (error.code !== ERROR.NOT_AUTHORIZED)
          this.setState({ errorMessage: error.message });
      }
    );
  };

  handleAddClick = (userInfo, callBack) => {
    userInfo.customerId = this.state.customerId;
    userAction.addUserAction(userInfo).then(
      response_data => {
        this.getCustomerStatistics();
        toastr.success(getMessage("USER_CREATED_SUCCESSFULLY"));
        this.getAllUserData();
        this.setState({ showAddUserModalFlag: false });
        this.adminDashboardRef.current
          && this.adminDashboardRef.current.resetValuesOnAddUser();
        if (callBack) callBack({ resp: "success" });
      },
      error => {
        if (callBack) callBack({ resp: "error", error: error });
      }
    );
  };

  handleSaveClick = (userInfo, callBackForError) => {
    userAction
    .saveUserAction(
      userInfo,
      userInfo.id,
      this.props.loggedUserId
    )
    .then(
      response_data => {
        this.getAllUserData(undefined, undefined, this.state.searchKey);
        this.setState({
          showEditUserModalFlag: false,
          editUserData: {
            id: "",
            first_name: "",
            last_name: "",
            role: "",
            email: "",
            customerId: this.props.customerId,
            status: "",
            isOperator: false,
            operatorSkills: [],
          },
          deleteTarget: "",
          originalSkills: [],
        });
        toastr.success(`${getMessage("USER_UPDATED_SUCCESSFULLY")}`);
      },
      error => {
        callBackForError(error);
      }
    );
  };

  handleDeleteUserClick = disableDeleteBtn => {
    if(disableDeleteBtn){
      disableDeleteBtn(true);
    }
    userAction.deleteUserAction(this.state.deleteUserIndex).then(
      response_data => {
        // decrement totalUserCount as user is deleted
        let newUserTotalCount = this.props.usersCount - 1;
        // calculate new total page count
        let newPageCount = Math.ceil(newUserTotalCount / this.props.userListPageSize);
        let currentPageNo = this.props.userListCurrentPageNo;
        console.log("currentPageNo: ", currentPageNo, "newPageCount: ", newPageCount, "newUserTotalCount: ", newUserTotalCount)
        // if total page count is changed and reducer count is more than new page count, set new page count in reducer
        if(currentPageNo > 0 && currentPageNo >= newPageCount) {
          userAction.saveUserListCurrentPageNo(newPageCount - 1);
          currentPageNo = newPageCount - 1;
        }
        this.getCustomerStatistics();
        this.getAllUserData(currentPageNo, undefined, this.state.searchKey);

        this.setState ({
          showConfirmationModalFlag: false,
          deleteUserIndex: null
        });
        toastr.success(`${getMessage("USER_DELETED_SUCCESSFULLY")}`);
      },
      error => {
        this.setState({
          showConfirmationModalFlag: false,
          deleteUserIndex: null
        });
        if (error.code !== ERROR.NOT_AUTHORIZED)
          toastr.error(getMessage(error.code));
      }
    );
  };

  handleResetPassword = (data, callback) => {
    data.userId = this.state.resetPasswordUserId;
    this.setState({ showResetPasswordModalFlag: false });
    let userData = Object.assign(
      {},
      {
        userId: this.state.resetPasswordUserId,
        language: this.props.language,
        newPassword: data.newPassword,
        confirmPassword: data.confirmPassword
      }
    );
    userAction.resetUserAction(userData).then(
      response => {
        this.setState({ showResetPasswordUsesIdModalFlag: false });
        toastr.success(`${getMessage("RESET_PASSWORD_SUCCESS")}`);
        if (callback) callback({ resp: "success" });
      },
      error => {
        if (callback) callback({ resp: "error", error: error });
      }
    );
  };

  handleInitializeClick = () => {
    this.setState({ showInitializeMfaModalFlag: false });
    let userData = Object.assign(
      {},
      {
        userId: this.state.initializeMfaUserId
      }
    );
    userAction.resetUserMfaAction(userData).then(
      response => {
        toastr.success(`${getMessage("MFA_RESET_SUCCESS")}`);
      },
      error => {
        toastr.error(`${getMessage(error.code)}`);
      }
    );
  };

  resetPasswordClick = (resetPasswordUserId, resetPasswordEmail, resetPasswordUsesId) => {
    this.setState({
      showResetPasswordModalFlag: resetPasswordUsesId === 1 ? false : true,
      resetPasswordUserId: resetPasswordUserId,
      resetPasswordEmail: resetPasswordEmail,
      showResetPasswordUsesIdModalFlag: false
    });
    if(resetPasswordUsesId) {
      this.setState({
        showResetPasswordUsesIdModalFlag: true
      });
    }
  };

  initializeMfaClick = (initializeMfaUserId, initializeMfaEmail) => {
    this.setState({
      showInitializeMfaModalFlag: true,
      initializeMfaUserId: initializeMfaUserId,
      initializeMfaEmail: initializeMfaEmail,
    });
  };

  showDeleteConfirmationModal = (userId, userEmail) => {
    this.setState({ deleteUserIndex: userId, deleteTarget: userEmail });
    this.setState({ showConfirmationModalFlag: true });
  };

  showAddUserModal = () => {
    if (this.state.usersList.length > 0) {
      let operatorSkills = _.cloneDeep(this.state.usersList[0].operatorSkills);
      operatorSkills = operatorSkills.map(skill => {
        skill.isSelected = false;
        return skill;
      });
      const user = {
        ...this.state.addUserdata,
        operatorSkills: operatorSkills,
      }
      this.setState({
        addUserdata: user,
      });
    }
    this.setState({ showAddUserModalFlag: true });
  };

  showBulkImportUserModal = () =>{
    this.setState({showBulkImportUserModalFlag: true});
  }

  showAddUserDropdown = () =>{
    this.setState({showAddUserDropdownFlag:!this.state.showAddUserDropdownFlag})
  }

  showEditUserModal = userId => {
    let userData = _.find(this.state.usersList, object => {
      return object.id === userId;
    });
    const user = _.cloneDeep(userData);
    const original = _.cloneDeep(user.operatorSkills);
    this.setState({
      editUserData: user,
      originalSkills: original,
      showEditUserModalFlag: true
    });
  };

  handleCancelClick = () => {
    this.setState({ showResetPasswordModalFlag: false });
    this.setState({ showResetPasswordUsesIdModalFlag: false})
    this.setState({ showInitializeMfaModalFlag: false });

    this.setState({ showConfirmationModalFlag: false });
  };

  handleCancelAddUserModal = () => {
    this.setState({ showAddUserModalFlag: false });
  };

  handleCloseBulkImportUsers = () => {
    this.setState({ showBulkImportUserModalFlag: false });
  };

  handleCancelEditModal = () => {
    this.setState({ showEditUserModalFlag: false });
  };

  showAboutOrgModal = () => {
    this.getCustomerInfo();
    this.setState({
      showAboutOrgModalFlag: true
    });
  };

  handleCancelAboutOrgModal = () => {
    this.setState({
      showAboutOrgModalFlag: false
    });
  };
  getBaseUrl = () => {
    let baseUrl = window.location.origin;

    if (!baseUrl) {
      baseUrl = window.location.protocol + "//"
        + window.location.hostname
        + (window.location.port ? ':' + window.location.port : '');
    }

    baseUrl += this.state.organizationData.uri_identifier ? "/" + this.state.organizationData.uri_identifier : '';
    baseUrl = baseUrl + "/startSession?licenseKey=" + this.state.organizationData.license_key;
    this.setState({ baseUrl: baseUrl })
  }

  showQRPopUp = () => {

    this.setState({
      showQRPopUp: !this.state.showQRPopUp
    });
  };

  getSessionInvitiesAndSessionDetails = (sessionKey) => {
    actionFactory.addInviteeAction(sessionKey).then(response =>{
      this.setState({inviteesList: response.data.invitees})
    },
    error => {
      console.log('error: ***', error);
    })
    //to get sessionDetails
    userAction.getSessionDetail(sessionKey).then(response =>{
      this.setState({sessionDetails: response.data});
      userAction.saveSessionKey(sessionKey);
    },
    error => {
      console.error('getSessionDetail error: ***', error);
    })

    //to get canvas and pdf list
    userAction.getSessionData(sessionKey).then(response => {
      this.setState({sessionObjects : response.data.data.sessionData});
    },
    error => {
      console.error('getSessionData error: ***', error);
    })

    //to get recording data list
    userAction.getRecordingData(sessionKey).then(response => {
      this.setState({recordingObjects : response.data.data.sessionData});
    },
    error => {
      console.error('getRecordingData error: ***', error);
    })
  }
  
  onBackClick = () => {
    this.setState({inviteesList: [], sessionDetails:null})
    userAction.saveSessionKey(null);
  }

  showSpinner = () => {
    this.setState({
      spinnerVisibility: true
    });
  };

  hideSpinner = () => {
    this.setState({
      spinnerVisibility: false
    });
  };
  
  handleBulkImportUsers = (fileObject, callback) => {
    var formData = new FormData();
    formData.append("file", fileObject);
    formData.append("exportScript", false);
    formData.append("customerId", this.state.customerId);
    this.showSpinner();
    userAction.importBulkUsersAction(formData).then(
      response => {
        this.hideSpinner();
        this.getCustomerStatistics();
        this.adminDashboardRef.current
          && this.adminDashboardRef.current.resetValuesOnAddUser();
        this.getAllUserData();
        if (response.data.data) {
          //Below condition checks if seats limit is reached.
          let isRecordNotProcessed = response.data.data.find(errorRecord => errorRecord.error.code == RECORD_NOT_PROCESSED); // isRecordNotProcessed return 1st record which satisfies given condition
          callback && callback(response.data.data, isRecordNotProcessed ? getMessage("BULK_IMPORT_ERROR_FOR_SEATS_LIMIT_REACHED") : getMessage("BULK_IMPORT_ERROR"), false, false);
        } else {
          this.setState({
            showBulkImportUserModalFlag: false,
          });
          toastr.success(`${getMessage("USER_RECORDS_PROCESSED_SUCCESSFULLY")}`);
        }
      },
      error => {
        this.hideSpinner();
        callback && callback(null, getMessage(error.code), false, true);
      }
    );
  }; 

  toggleAddUserDropdown = () => {
    this.setState({
      showAddUserDropdownFlag: !this.state.showAddUserDropdownFlag
    });
  }

  renderComponents = () => {
    switch(this.props.location.pathname) {
      case CONFIG.path.admin:
        return (
          <AdminDashboard
            ref={this.adminDashboardRef}
            showTable={this.state.showTable}
            organisationName={this.state.organizationData.name}
            customerStatistics={this.state.customerStatistics}
            showConfirmationModalFlag={this.state.showConfirmationModalFlag}
            showResetPasswordModalFlag={this.state.showResetPasswordModalFlag}
            showResetPasswordUsesIdModalFlag={this.state.showResetPasswordUsesIdModalFlag}
            resetPasswordEmail={this.state.resetPasswordEmail}
            showAddUserModal={this.showAddUserModal}
            showBulkImportUserModal={this.showBulkImportUserModal}
            showAddUserDropdown={this.showAddUserDropdown}
            showEditUserModal={this.showEditUserModal}
            resetPasswordClick={this.resetPasswordClick}
            setPasswordTarget={this.state.setPasswordTarget}
            handleCancelClick={this.handleCancelClick}
            handleResetPassword={this.handleResetPassword}
            handleDeleteUserClick={this.handleDeleteUserClick}
            showDeleteConfirmationModal={this.showDeleteConfirmationModal}
            deleteTarget={this.state.deleteTarget}
            history={this.props.history}
            getAllUserData={this.getAllUserData}
            showAboutOrgModal={this.showAboutOrgModal}
            handleSaveClick={this.handleSaveClick}
            logoUrl={this.props.logoUrl}
            loggedUserId={this.props.loggedUserId}
            showQRPopUp={this.showQRPopUp}
            showQR={this.state.showQR}
            sessionsList={this.state.sessionsList}
            sessionsCount={this.props.sessionsCount}
            fetchSessionsList={this.fetchSessionsList}
            sessionListCurrentPageNo={this.props.sessionListCurrentPageNo}
            sessionDetails={this.state.sessionDetails}
            sessionKey={this.props.sessionKey}
            inviteesList={this.state.inviteesList}
            getSessionInvitiesAndSessionDetails={this.getSessionInvitiesAndSessionDetails}
            onBackClick={this.onBackClick}
            language={this.props.language}
            currentActiveTab={this.props.currentActiveTab}
            sessionObjects={this.state.sessionObjects}
            recordingObjects={this.state.recordingObjects}
            showSpinner={this.showSpinner}
            hideSpinner={this.hideSpinner}
            sessionListPageSize={this.props.sessionListPageSize}
            userListPageSize={this.props.userListPageSize}
            userListCurrentPageNo={this.props.userListCurrentPageNo}
            usersList={this.state.usersList}
            usersCount={this.props.usersCount}
            isSSOEnabled={this.state.organizationData.SSODetails?.isSSOEnabled}
            modules={this.state.organizationData.modules}
            smsSendNumber={this.smsSendNumber}
            smsSendNumList={this.state.smsSendNumList}
            encodingTime={this.encodingTime}
            encodingTimeList={this.state.encodingTimeList}
            initializeMfaClick={this.initializeMfaClick}
            handleInitializeClick={this.handleInitializeClick}
            initializeMfaEmail={this.state.initializeMfaEmail}
            showInitializeMfaModalFlag={this.state.showInitializeMfaModalFlag}
            customerId={this.props.customerId}
          />
        );
      case CONFIG.path.supportCenter:
        return (
          <SupportCenterContainer
            history={this.props.history}
            showAddUserModal={this.showAddUserModal}
            showAddUserDropdown={this.showAddUserDropdown}
            showAboutOrgModal={this.showAboutOrgModal}
            getAllUserData={this.getAllUserData}
            logoUrl={this.props.logoUrl}
            showQRPopUp={this.showQRPopUp}
            showQR={this.state.showQR}
          />
        );
      
      case CONFIG.path.supportCenterReport:
        return (
          <SupportCenterReportContainer
            organisationName={this.state.organizationData.name}
            showAddUserModal={this.showAddUserModal}
            showAddUserDropdown={this.showAddUserDropdown}
            showAboutOrgModal={this.showAboutOrgModal}
            showBulkImportUserModal={this.showBulkImportUserModal}
            getAllUserData={this.getAllUserData}
            showQRPopUp={this.showQRPopUp}
            showQR={this.state.showQR}
          />
        );
    }
  }

  render() {
    return (
      <div>
        {this.renderSpinner()}
        <AddUserModal
          show={this.state.showAddUserModalFlag}
          addUserdata={this.state.addUserdata}
          handleAddClick={this.handleAddClick}
          handleCancelClick={this.handleCancelAddUserModal}
          language={this.props.language}
          isSupportCenter={this.state.isSupportCenter}
        />

        <BulkImportUserModal
          show={this.state.showBulkImportUserModalFlag}
          handleBulkImportUsers={this.handleBulkImportUsers}
          handleCloseBulkImportUsers={this.handleCloseBulkImportUsers}
          language={this.props.language}
          getAllUserData={this.getAllUserData}
          userListPageSize={this.props.userListPageSize}
        />

        <AddUserDropdown
          show={this.state.showAddUserDropdownFlag}
          toggleAddUserDropdown={this.toggleAddUserDropdown}
          showAddUserModal={this.showAddUserModal}
          showBulkImportUserModal={this.showBulkImportUserModal}
          language={this.props.language}
          customerId={this.props.customerId}
        />

        <EditUserModal
          show={this.state.showEditUserModalFlag}
          editUserData={this.state.editUserData}
          handleSaveClick={this.handleSaveClick}
          handleCancelClick={this.handleCancelEditModal}
          language={this.props.language}
          isSupportCenter={this.state.isSupportCenter}
          originalSkills={this.state.originalSkills}
        />

        <QRPopUp
          show={this.state.showQRPopUp}
          showQRPopUp={this.showQRPopUp}
          qrurl={this.state.baseUrl}
        />

        <AboutOrganisationModal
          show={this.state.showAboutOrgModalFlag}
          handleCancelClick={this.handleCancelAboutOrgModal}
          organizationData={this.state.organizationData}
          customerId={this.props.customerId}
          uploadImage={this.uploadImage}
          hideSpinner={this.hideSpinner}

        />

        {this.renderComponents()}

      </div>
    );
  }

  componentWillUnmount() {
    //toastr.removeByType("success");
    //toastr.removeByType("error");
    toast.dismiss();
  }
}

const mapStateToProps = state => {
  return {
    customerId: getCustomerId(state),
    loggedUserId: getUserId(state),
    logoUrl: state.OrganisationReducer.logoUrl,
    sessionsCount: getSessionsCount(state),
    usersCount: getUsersCount(state),
    language: state.LanguageReducer.language,
    currentActiveTab:state.AdminReducer.currentActiveTab,
    sessionKey:state.AdminReducer.sessionKey,
    sessionListPageSize: getSessionListPageSize(state),
    sessionListCurrentPageNo: getSessionListCurrentPageNo(state),
    userListPageSize: getUserListPageSize(state),
    userListCurrentPageNo: getUserListCurrentPageNo(state),
    isSSOEnabled: getIsSSOEnabled(state),
    smsSentNumPageNo: getSmsSentNumPageNo(state),
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersContainer);
